// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_read_status-module__container--28Yy-"};